// import { useLocation } from "react-router-dom";
// import { Menu, Bell, Calendar } from "lucide-react";
// import { routes } from "../routes/routeConfig";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// //const Topbar = ({ setOpen }) => {
// // const Topbar = ({ setOpen, selectedDate, setSelectedDate }) => {
// const Topbar = ({
//   setOpen,
//   selectedDate,
//   setSelectedDate
// }) => {

//   const location = useLocation();
//   const [showCalendar, setShowCalendar] = useState(false);
//   // const [selectedDate, setSelectedDate] = useState(new Date());
//   const navigate = useNavigate();

//   const currentRoute = routes
//     .filter((r) => r.title && r.path !== "/")
//     .sort((a, b) => b.path.length - a.path.length)
//     .find((r) => location.pathname.startsWith(r.path));

//   const title = currentRoute?.title || "Dashboard";

//   const isLiveClassPage = location.pathname === "/live-classes";

//   return (

//     <>
//       <div className="bg-primary sticky text-white px-4 md:px-6 py-3 flex items-center justify-between shadow">

//         {/* Left */}
//         <div className="flex items-center gap-3">

//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden"
//             onClick={() => setOpen(true)}
//           >
//             <Menu className="w-6 h-6" />
//           </button>
//           <h1 className="text-base md:text-lg font-semibold uppercase truncate max-w-[150px] md:max-w-none">
//             {title}
//           </h1>

//         </div>
//         {/*
//       Right
//       <div className="flex items-center gap-3 md:gap-4 text-sm">

//         <span className="hidden sm:block">Today’s Session</span>

//         <div className="bg-white text-black px-3 py-1 rounded-full text-xs md:text-sm">
//           {new Date().toLocaleDateString()}
//         </div>

//         <div className="w-8 h-8 bg-white rounded-full" />

//       </div> */}
//         <div className="flex items-center gap-3 md:gap-4 text-sm">


//           {/* Hide on very small screens */}
//           {isLiveClassPage && (
//             <>
//               <span className="hidden sm:block">Today’s Session</span>

//               {/* DATE DISPLAY */}
//               <div className="bg-primary text-white">
//                 {selectedDate.toLocaleDateString()}
//               </div>

//               {/* CALENDAR ICON */}
//               <button
//                 onClick={() => setShowCalendar(!showCalendar)}
//                 className="p-2 rounded-full hover:bg-white/20 transition relative"
//               >
//                 <Calendar className="w-4 h-4 md:w-5 md:h-5" />
//               </button>
//             </>
//           )}
//           {/* Notification Icon (only on tablet+) */}
//           <Bell className="w-5 h-5 hidden sm:block" />

//           {/* Profile */}
//           <div className="w-8 h-8 bg-white rounded-full" />
//         </div>
//       </div>

//       {/* CALENDAR POPUP */}
//       {showCalendar && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

//           <div className="bg-white rounded-lg p-4 shadow-lg">

//             <DatePicker
//               selected={selectedDate}
//               onChange={(date) => {
//                 setSelectedDate(date);
//                 setShowCalendar(false);
//               }}
//               inline
//             />

//           </div>
//         </div>
//       )}
//     </>


//   );
// };

// export default Topbar;



// import { useLocation } from "react-router-dom";
// import { Menu, Calendar, Home } from "lucide-react";
// import { routes } from "../routes/routeConfig";
// import { useState } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const Topbar = ({
//   setOpen,
//   selectedDate,
//   setSelectedDate,
// }) => {
//   const location = useLocation();

//   const [showCalendar, setShowCalendar] = useState(false);

//   // =====================================================
//   // CURRENT ROUTE
//   // =====================================================

//   const currentRoute = routes
//     .filter(
//       (r) =>
//         r.title &&
//         r.path !== "/"
//     )
//     .sort(
//       (a, b) =>
//         b.path.length - a.path.length
//     )
//     .find((r) =>
//       location.pathname.startsWith(r.path)
//     );

//   const title =
//     currentRoute?.title || "Dashboard";

//   const isLiveClassPage =
//     location.pathname === "/live-classes";

//   // =====================================================
//   // DATE FORMAT
//   // =====================================================

//   const formatDate = (date) => {
//     if (!date) return "";

//     return date.toLocaleDateString(
//       "en-GB",
//       {
//         weekday: "short",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       }
//     );
//   };

//   return (
//     <>
//       {/* =====================================================
//           OUTER CONTAINER
//           No white background
//       ===================================================== */}

//       <div
//         className="
//           w-full
//           bg-secondary

//           px-2
//           sm:px-3
//           md:px-4
//           lg:px-6

//           py-2
//         "
//       >
//         {/* =================================================
//             TOPBAR
//         ================================================= */}

//         <div
//           className="
//             w-full

//             bg-[#3F35C7]
//             text-white

//             rounded-[18px]

//             overflow-hidden

//             shadow-none
//           "
//         >

//           {/* =================================================
//               MOBILE
//               < 640px
//           ================================================= */}

//           <div
//             className="
//               sm:hidden

//               w-full
//               min-w-0

//               px-4
//               py-4
//             "
//           >

//             {/* TOP ROW */}

//             <div
//               className="
//                 w-full
//                 flex
//                 items-center
//                 justify-between

//                 min-w-0
//               "
//             >

//               {/* LEFT */}

//               <div
//                 className="
//                   flex
//                   items-center
//                   gap-2

//                   min-w-0
//                 "
//               >

//                 {/* MENU */}

//                 <button
//                   type="button"
//                   onClick={() => setOpen(true)}
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10

//                     transition
//                   "
//                   aria-label="Open menu"
//                 >
//                   <Menu
//                     className="w-5 h-5"
//                   />
//                 </button>

//                 {/* TITLE */}

//                 <h1
//                   className="
//                     text-[19px]

//                     font-bold
//                     uppercase

//                     whitespace-nowrap
//                     truncate
//                   "
//                 >
//                   {title}
//                 </h1>

//               </div>

//               {/* HOME */}

//               <button
//                 type="button"
//                 className="
//                   w-8
//                   h-8

//                   shrink-0

//                   flex
//                   items-center
//                   justify-center

//                   rounded-full

//                   hover:bg-white/10
//                 "
//                 aria-label="Home"
//               >
//                 <Home
//                   className="w-5 h-5"
//                 />
//               </button>

//             </div>

//             {/* TODAY'S SESSION */}

//             {isLiveClassPage && (
//               <div
//                 className="
//                   w-full

//                   flex
//                   items-center
//                   justify-center

//                   mt-2
//                 "
//               >
//                 <span
//                   className="
//                     text-[16px]
//                     font-medium
//                     whitespace-nowrap
//                   "
//                 >
//                   Today's session
//                 </span>
//               </div>
//             )}

//             {/* DATE ROW */}

//             {isLiveClassPage && (
//               <div
//                 className="
//                   w-full
//                   min-w-0

//                   flex
//                   items-center
//                   justify-center

//                   gap-1

//                   mt-2
//                 "
//               >

//                 {/* PREVIOUS */}

//                 <button
//                   type="button"
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Previous date"
//                 >
//                   <span
//                     className="
//                       text-[22px]
//                       leading-none
//                     "
//                   >
//                     ‹
//                   </span>
//                 </button>

//                 {/* DATE */}

//                 <div
//                   className="
//                     h-[46px]

//                     flex
//                     items-center
//                     justify-center

//                     flex-1
//                     min-w-0

//                     max-w-[190px]

//                     px-3

//                     bg-white
//                     text-[#241d69]

//                     rounded-full

//                     text-[13px]
//                     font-medium

//                     whitespace-nowrap
//                     overflow-hidden
//                   "
//                 >
//                   <span className="truncate">
//                     {formatDate(selectedDate)}
//                   </span>
//                 </div>

//                 {/* NEXT */}

//                 <button
//                   type="button"
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Next date"
//                 >
//                   <span
//                     className="
//                       text-[22px]
//                       leading-none
//                     "
//                   >
//                     ›
//                   </span>
//                 </button>

//                 {/* CALENDAR */}

//                 <button
//                   type="button"
//                   onClick={() =>
//                     setShowCalendar(
//                       !showCalendar
//                     )
//                   }
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Calendar"
//                 >
//                   <Calendar
//                     className="w-5 h-5"
//                   />
//                 </button>

//               </div>
//             )}

//           </div>

//           {/* =================================================
//               TABLET
//               640px - 767px
//           ================================================= */}

//           <div
//             className="
//               hidden
//               sm:flex
//               md:hidden

//               w-full

//               min-h-[78px]

//               px-5
//               py-3

//               items-center
//               justify-between

//               gap-4
//             "
//           >

//             {/* LEFT */}

//             <div
//               className="
//                 flex
//                 items-center
//                 gap-2

//                 min-w-0
//               "
//             >

//               <button
//                 type="button"
//                 onClick={() => setOpen(true)}
//                 className="
//                   w-8
//                   h-8

//                   shrink-0

//                   flex
//                   items-center
//                   justify-center

//                   rounded-full

//                   hover:bg-white/10
//                 "
//                 aria-label="Open menu"
//               >
//                 <Menu
//                   className="w-5 h-5"
//                 />
//               </button>

//               <h1
//                 className="
//                   text-[20px]

//                   font-bold
//                   uppercase

//                   whitespace-nowrap
//                   truncate
//                 "
//               >
//                 {title}
//               </h1>

//             </div>

//             {/* CENTER */}

//             {isLiveClassPage && (
//               <div
//                 className="
//                   flex
//                   items-center
//                   justify-center

//                   gap-2

//                   min-w-0
//                 "
//               >

//                 <span
//                   className="
//                     text-[15px]
//                     whitespace-nowrap
//                   "
//                 >
//                   Today's session
//                 </span>

//                 {/* PREVIOUS */}

//                 <button
//                   type="button"
//                   className="
//                     w-7
//                     h-7

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Previous date"
//                 >
//                   ‹
//                 </button>

//                 {/* DATE */}

//                 <div
//                   className="
//                     bg-white
//                     text-[#241d69]

//                     rounded-full

//                     px-4
//                     py-2

//                     text-[13px]
//                     font-medium

//                     whitespace-nowrap
//                   "
//                 >
//                   {formatDate(selectedDate)}
//                 </div>

//                 {/* NEXT */}

//                 <button
//                   type="button"
//                   className="
//                     w-7
//                     h-7

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Next date"
//                 >
//                   ›
//                 </button>

//                 {/* CALENDAR */}

//                 <button
//                   type="button"
//                   onClick={() =>
//                     setShowCalendar(
//                       !showCalendar
//                     )
//                   }
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Calendar"
//                 >
//                   <Calendar
//                     className="w-5 h-5"
//                   />
//                 </button>

//               </div>
//             )}

//             {/* RIGHT */}

//             <Home
//               className="
//                 w-5
//                 h-5

//                 shrink-0
//               "
//             />

//           </div>

//           {/* =================================================
//               DESKTOP
//               >= 768px
//           ================================================= */}

//           <div
//             className="
//               hidden
//               md:flex

//               w-full

//               min-h-[74px]

//               px-6

//               items-center
//               justify-between

//               gap-6
//             "
//           >

//             {/* LEFT */}

//             <div
//               className="
//                 flex
//                 items-center

//                 min-w-[180px]
//               "
//             >
//               <h1
//                 className="
//                   text-[20px]
//                   lg:text-[21px]

//                   font-bold
//                   uppercase

//                   whitespace-nowrap
//                 "
//               >
//                 {title}
//               </h1>
//             </div>

//             {/* CENTER */}

//             {isLiveClassPage && (
//               <div
//                 className="
//                   flex
//                   items-center
//                   justify-center

//                   gap-4

//                   flex-1
//                   min-w-0
//                 "
//               >

//                 {/* TODAY */}

//                 <span
//                   className="
//                     text-[16px]
//                     lg:text-[17px]

//                     whitespace-nowrap
//                   "
//                 >
//                   Today's session
//                 </span>

//                 {/* PREVIOUS */}

//                 <button
//                   type="button"
//                   className="
//                     w-7
//                     h-7

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     text-lg

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Previous date"
//                 >
//                   ‹
//                 </button>

//                 {/* DATE */}

//                 <div
//                   className="
//                     bg-white
//                     text-[#241d69]

//                     rounded-full

//                     min-w-[194px]

//                     px-6
//                     py-2.5

//                     flex
//                     items-center
//                     justify-center

//                     text-[15px]
//                     font-semibold

//                     whitespace-nowrap
//                   "
//                 >
//                   {formatDate(selectedDate)}
//                 </div>

//                 {/* NEXT */}

//                 <button
//                   type="button"
//                   className="
//                     w-7
//                     h-7

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     text-lg

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Next date"
//                 >
//                   ›
//                 </button>

//                 {/* CALENDAR */}

//                 <button
//                   type="button"
//                   onClick={() =>
//                     setShowCalendar(
//                       !showCalendar
//                     )
//                   }
//                   className="
//                     w-8
//                     h-8

//                     shrink-0

//                     flex
//                     items-center
//                     justify-center

//                     rounded-full

//                     hover:bg-white/10
//                   "
//                   aria-label="Calendar"
//                 >
//                   <Calendar
//                     className="w-5 h-5"
//                   />
//                 </button>

//               </div>
//             )}

//             {/* RIGHT */}

//             <div
//               className="
//                 flex
//                 items-center
//                 justify-end

//                 min-w-[70px]
//               "
//             >
//               <Home
//                 className="w-5 h-5"
//               />
//             </div>

//           </div>

//         </div>
//       </div>

//       {/* =====================================================
//           CALENDAR POPUP
//       ===================================================== */}

//       {showCalendar && (
//         <div
//           className="
//             fixed
//             inset-0

//             z-[100]

//             bg-black/40

//             flex
//             items-center
//             justify-center

//             p-4
//           "
//           onClick={() =>
//             setShowCalendar(false)
//           }
//         >

//           <div
//             className="
//               bg-white

//               rounded-2xl

//               p-4

//               shadow-2xl

//               max-w-full
//             "
//             onClick={(e) =>
//               e.stopPropagation()
//             }
//           >

//             <DatePicker
//               selected={selectedDate}
//               onChange={(date) => {
//                 if (date) {
//                   setSelectedDate(date);
//                 }

//                 setShowCalendar(false);
//               }}
//               inline
//             />

//           </div>

//         </div>
//       )}

//     </>
//   );
// };

// export default Topbar;



import { useLocation } from "react-router-dom";
import { Menu, Calendar, Home } from "lucide-react";
import { routes } from "../routes/routeConfig";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Topbar = ({
  setOpen,
  selectedDate,
  setSelectedDate,
}) => {
  const location = useLocation();
  const [showCalendar, setShowCalendar] = useState(false);

  // ============================================
  // CURRENT ROUTE
  // ============================================

  const currentRoute = routes
    .filter(
      (r) =>
        r.title &&
        r.path !== "/"
    )
    .sort(
      (a, b) =>
        b.path.length - a.path.length
    )
    .find((r) =>
      location.pathname.startsWith(r.path)
    );

  const title =
    currentRoute?.title || "Dashboard";

  const isLiveClassPage =
    location.pathname === "/live-classes";

  // ============================================
  // DATE FORMAT
  // ============================================

  const formatDate = (date) => {
    if (!date) return "";

    return date.toLocaleDateString(
      "en-GB",
      {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );
  };

  return (
    <>
      {/* =================================================
          OUTER CONTAINER
      ================================================= */}

      <div
        className="
          w-full
          bg-secondary
          px-2
          sm:px-3
          md:px-4
          lg:px-6
          py-2
        "
      >

        {/* =================================================
            TOPBAR
        ================================================= */}

        <div
          className="
            w-full
            bg-[#3F35C7]
            text-white
            rounded-[18px]
            overflow-hidden
          "
        >

          {/* =================================================
              MOBILE ONLY
              < 640px
          ================================================= */}

          <div
            className="
              sm:hidden

              w-full
              min-w-0

              px-3
              py-3
            "
          >

            <div
              className="
                flex
                items-center
                w-full
                gap-2
              "
            >

              {/* MENU */}

              <button
                type="button"
                onClick={() => setOpen(true)}
                className="
                  w-8
                  h-8
                  shrink-0

                  flex
                  items-center
                  justify-center

                  rounded-full

                  hover:bg-white/10
                "
                aria-label="Open menu"
              >
                <Menu
                  className="w-6 h-6"
                  strokeWidth={2}
                />
              </button>


              {/* LIVE CLASS */}

              <h1
                className="
                  text-[19px]
                  font-bold
                  uppercase

                  whitespace-nowrap
                  shrink-0
                "
              >
                {title}
              </h1>


              {/* DATE */}

              {isLiveClassPage && (
                <div
                  className="
                    ml-auto

                    flex
                    items-center
                    gap-1

                    min-w-0
                  "
                >

                  <span
                    className="
                      text-[12px]
                      font-medium

                      whitespace-nowrap
                    "
                  >
                    {formatDate(selectedDate)}
                  </span>


                  {/* CALENDAR */}

                  <button
                    type="button"
                    onClick={() =>
                      setShowCalendar(
                        !showCalendar
                      )
                    }
                    className="
                      w-8
                      h-8

                      shrink-0

                      flex
                      items-center
                      justify-center

                      rounded-full

                      hover:bg-white/10
                    "
                    aria-label="Calendar"
                  >
                    <Calendar
                      className="w-5 h-5"
                      strokeWidth={2}
                    />
                  </button>


                  {/* HOME */}

                  <button
                    type="button"
                    className="
                      w-8
                      h-8

                      shrink-0

                      flex
                      items-center
                      justify-center

                      rounded-full

                      hover:bg-white/10
                    "
                    aria-label="Home"
                  >
                    <Home
                      className="w-5 h-5"
                      strokeWidth={2}
                    />
                  </button>

                </div>
              )}

            </div>

          </div>


          {/* =================================================
              TABLET
              640px - 767px
              UNCHANGED
          ================================================= */}

          <div
            className="
              hidden
              sm:flex
              md:hidden

              min-h-[78px]

              px-5
              py-3

              items-center
              justify-between

              gap-4
            "
          >

            {/* MENU + TITLE */}

            <div
              className="
                flex
                items-center
                gap-2
                min-w-0
              "
            >

              <button
                type="button"
                onClick={() => setOpen(true)}
                className="
                  w-8
                  h-8
                  shrink-0

                  flex
                  items-center
                  justify-center

                  rounded-full

                  hover:bg-white/10
                "
                aria-label="Open menu"
              >
                <Menu
                  className="w-6 h-6"
                />
              </button>

              <h1
                className="
                  text-[20px]
                  font-bold
                  uppercase
                  whitespace-nowrap
                "
              >
                {title}
              </h1>

            </div>


            {/* CENTER */}

            {isLiveClassPage && (
              <div
                className="
                  flex
                  items-center
                  justify-center
                  gap-2
                  min-w-0
                "
              >

                <span
                  className="
                    text-[15px]
                    whitespace-nowrap
                  "
                >
                  Today's session
                </span>

                <button
                  type="button"
                  className="
                    w-7
                    h-7
                    shrink-0
                  "
                >
                  ‹
                </button>

                <div
                  className="
                    bg-white
                    text-[#241d69]

                    rounded-full

                    px-4
                    py-2

                    text-[13px]
                    font-semibold

                    whitespace-nowrap
                  "
                >
                  {formatDate(selectedDate)}
                </div>

                <button
                  type="button"
                  className="
                    w-7
                    h-7
                    shrink-0
                  "
                >
                  ›
                </button>

                <button
                  type="button"
                  onClick={() =>
                    setShowCalendar(
                      !showCalendar
                    )
                  }
                  className="
                    w-8
                    h-8
                    shrink-0

                    flex
                    items-center
                    justify-center

                    rounded-full

                    hover:bg-white/10
                  "
                  aria-label="Calendar"
                >
                  <Calendar
                    className="w-5 h-5"
                  />
                </button>

              </div>
            )}


            {/* HOME */}

            <Home
              className="
                w-6
                h-6
                shrink-0
              "
            />

          </div>


          {/* =================================================
              DESKTOP
              >= 768px
              UNCHANGED
          ================================================= */}

          <div
            className="
              hidden
              md:flex

              min-h-[74px]

              px-6

              items-center
              justify-between

              gap-6
            "
          >

            {/* LEFT */}

            <div
              className="
                flex
                items-center
                min-w-[180px]
              "
            >

              <h1
                className="
                  text-[20px]
                  lg:text-[21px]

                  font-bold
                  uppercase

                  whitespace-nowrap
                "
              >
                {title}
              </h1>

            </div>


            {/* CENTER */}

            {isLiveClassPage && (
              <div
                className="
                  flex
                  items-center
                  justify-center

                  gap-4

                  flex-1
                  min-w-0
                "
              >

                <span
                  className="
                    text-[16px]
                    lg:text-[17px]

                    whitespace-nowrap
                  "
                >
                  Today's session
                </span>


                <button
                  type="button"
                  className="
                    w-7
                    h-7
                    shrink-0

                    flex
                    items-center
                    justify-center
                  "
                >
                  ‹
                </button>


                <div
                  className="
                    bg-white
                    text-[#241d69]

                    rounded-full

                    min-w-[194px]

                    px-6
                    py-2.5

                    flex
                    items-center
                    justify-center

                    text-[15px]
                    font-semibold

                    whitespace-nowrap
                  "
                >
                  {formatDate(selectedDate)}
                </div>


                <button
                  type="button"
                  className="
                    w-7
                    h-7
                    shrink-0

                    flex
                    items-center
                    justify-center
                  "
                >
                  ›
                </button>


                <button
                  type="button"
                  onClick={() =>
                    setShowCalendar(
                      !showCalendar
                    )
                  }
                  className="
                    w-8
                    h-8
                    shrink-0

                    flex
                    items-center
                    justify-center

                    rounded-full

                    hover:bg-white/10
                  "
                  aria-label="Calendar"
                >
                  <Calendar
                    className="w-5 h-5"
                  />
                </button>

              </div>
            )}


            {/* HOME */}

            <div
              className="
                flex
                items-center
                justify-end

                min-w-[70px]
              "
            >
              <Home
                className="w-5 h-5"
              />
            </div>

          </div>

        </div>
      </div>


      {/* =====================================================
          CALENDAR POPUP
      ===================================================== */}

      {showCalendar && (
        <div
          className="
            fixed
            inset-0
            z-[100]

            bg-black/40

            flex
            items-center
            justify-center

            p-4
          "
          onClick={() =>
            setShowCalendar(false)
          }
        >

          <div
            className="
              bg-white
              rounded-2xl
              p-4
              shadow-2xl
              max-w-full
            "
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                if (date) {
                  setSelectedDate(date);
                }

                setShowCalendar(false);
              }}
              inline
            />

          </div>

        </div>
      )}
    </>
  );
};

export default Topbar;